import { useMemo } from 'react';
import { ServiceNotAvailableError } from 'components/content/error/ServiceNotAvailableError';
import { NoProductsAvailableError } from 'components/content/error/NoProductsAvailableError';
import { ClientError } from '@cobra/fe-lib/client-error-handling/classes/ClientError';
import {
    AaxUnavailableErrorResult,
    InvalidParametersErrorResult,
    NoProductsAvailableErrorResult,
} from '@cobra/fe-lib/client-error-handling/classes/ErrorResult';

export const useDisplayErrorForAvailabilityCheck = (
    error:
        | ClientError<NoProductsAvailableErrorResult | AaxUnavailableErrorResult | InvalidParametersErrorResult>
        | undefined
) =>
    useMemo(() => {
        if (!error) {
            return null;
        }
        switch (error.title) {
            case 'NO_PRODUCTS_AVAILABLE':
                return <NoProductsAvailableError />;
            case 'AAX_UNAVAILABLE':
            case 'INVALID_PARAMETER':
            default:
                return <ServiceNotAvailableError />;
        }
    }, [error]);
